import React from 'react'



const Tiktok = (props: React.SVGProps<SVGSVGElement>) => (

<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<g clipPath="url(#clip0_6003_2946)">
<path d="M14.7339 0.457031H11.4189V13.8552C11.4189 15.4516 10.144 16.763 8.55737 16.763C6.97074 16.763 5.69577 15.4516 5.69577 13.8552C5.69577 12.2874 6.94241 11.0045 8.47239 10.9476V7.58376C5.10079 7.64074 2.38086 10.4059 2.38086 13.8552C2.38086 17.3331 5.15745 20.1268 8.58571 20.1268C12.0139 20.1268 14.7905 17.3046 14.7905 13.8552V6.98509C16.0372 7.89732 17.5671 8.43895 19.1821 8.46747V5.10365C16.6888 5.01813 14.7339 2.96563 14.7339 0.457031Z" 
fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_6003_2946">
<rect width="19.6697" height="19.6697" fill="currentColor" transform="translate(0.742188 0.457031)"/>
</clipPath>
</defs>
</svg>
)
export default Tiktok
